import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { localStorageService } from '@web/service';

export const liveI18NModeGuardFn: CanActivateFn = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const liveI18Mode = route.queryParams['mode'] ?? 'disabled';
  localStorageService.setItem('liveI18NMode', liveI18Mode);
  return false;
};
